import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreVertIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 18.5,
			r: 1.5,
			fill: "#757783"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 12.5,
			r: 1.5,
			fill: "#757783"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 6.5,
			r: 1.5,
			fill: "#757783"
		})
	]
});
const ForwardRef = forwardRef(SvgMoreVertIcon);
export default ForwardRef;
